<template>
    <Modal
        v-model="visible"
        :mask-closable="false"
        @cancel="$emit('cancel')"
    >
        <div slot="header" class="ivu-modal-header-inner">
            <div v-html="$t('Message.remove.confirmTip', {
                    confirm: $t('Message.remove.confirm').bold().fontcolor('red'),
                })"></div>
        </div>
        <Form :label-width="0">
            <FormItem
                style="margin-bottom: 0"
            >
                <Input v-model="value" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="error" size="large" @click="onRemove">{{
                $t("Button.remove")
            }}</Button>
            <Button size="large" @click="$emit('cancel')">{{
                $t("Button.cancel")
            }}</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    props: ["visible", "title"],
    data() {
        return { value: "" };
    },
    methods: {
        onRemove() {
            let val = this.value;
            if (val == this.$t("Message.remove.confirm")) {
                this.$emit("remove", val);
            } else {
                this.$Message.info(this.$t("Message.remove.error"));
                this.$emit("cancel");
            }
        },
    },
};
</script>
<style lang="less" scoped>
</style>
